import { Button, ButtonType, BackButton, DialogHeader } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import Dialog from 'material-ui/Dialog';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { UserEditDialogForm } from '../../../services/enums/users';
import DirectoryUserContainer from '../directoryUsers';
import ImportUserButtonContainer from '../directoryUsers/importUserButton';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import { UserEditFormMode } from '../../../services/enums/users';
import AddEditUsersTabs from '../addEditUser/addEditUsersTabs';
import styles from './style.scss';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'addEditUserStore', 'usersStore') @observer
export default class EditUserDialogContainer extends Component {

    t = this.props.translationsStore;
    
    componentWillMount() {

        this.props.addEditUserStore.setIsAddUserError(false);
        this.props.addEditUserStore.setAddUserErrorMessage('');
    }

    handleSuccessfulSaveOperation() {

        this.props.usersStore.getAllUsers();
        this.props.closeAddUserModal();
        
        var level = ToastrLevelsEnum.SUCCESS;
        var message = this.t.translate('USER_CREATED_SUCCESS_MESSAGE');
        ToastrService.triggerToastr({level, message});

        this.props.addEditUserStore.reset();
    }

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.addEditUserStore.setAddUserErrorMessage('');
        
        if (this.props.addEditUserStore.formMode === UserEditFormMode.add) {
        
            const isValid = this.props.addEditUserStore.validateAddForm();

            if (isValid === false) {

                this.props.addEditUserStore.setIsAddUserError(true);
                const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
                this.props.addEditUserStore.setAddUserErrorMessage(validationErrorMessage);
                return;
            }

            this.props.addEditUserStore.createUser().then(() => {
            
                this.handleSuccessfulSaveOperation();
            });
        }
    }

    render() {

        let title, content, link, className = '';

        if (this.props.mode === undefined || this.props.mode === UserEditDialogForm.add) {
        
            title = this.t.translate('ADD_NEW_USER');
            link = <ImportUserButtonContainer
                        formMode={1}
                        openImportUserDialog={this.props.switchToImportLDAPForm}
                    />;
            content = <form onSubmit={this.handleSubmitForm}>
                        <AddEditUsersTabs />
                    </form>;
        }
        else if(this.props.mode === UserEditDialogForm.importFromDirectory) {

            title = this.t.translate('IMPORT_DIRECTORY_USER_DETAILS');
            link = <div
                        style={{
                            marginBottom: 5
                        }}
                    >
                        <BackButton
                            dataCy='back-to-create-user-button'
                            onClick={this.props.switchToAddUserFrom}
                            text={this.t.translate('BACK')}
                            title={this.t.translate('BACK')}
                        />
                    </div>
                    ;
            content = <DirectoryUserContainer
                        formMode={1}
                        openAddUserModal={this.openAddUserModal}
                    />;
            className = 'create-user-dialog-header';
        }
        
        const actions = this.props.mode === UserEditDialogForm.importFromDirectory ? null : <div className='user-form-buttons-container'>
                            <span className='portal-blank-button' onClick={this.props.closeAddUserModal} data-cy='cancel-user-button'>
                                {this.props.translationsStore.translate('CANCEL')}
                            </span>
                            <Button
                                type='submit'
                                dataCy='save-user-button'
                                onClick={this.handleSubmitForm}
                                inProgress={this.props.addEditUserStore.creatingUser || this.props.addEditUserStore.updatingUser}
                                text={this.props.translationsStore.translate('SAVE')}>
                            </Button>
                        </div>;

        return (
            <Dialog 
                className={classNames(styles.ldapAddGroupsHeader)}
                open={this.props.show}
                repositionOnUpdate={false}
                actions={actions}
                actionsContainerStyle={{padding: 0}}
                customContentStyle={{
                    width: '100%',
                    maxWidth: 'none',
                    height: '60vh'
                  }}
            >
                <div className={classNames(styles.dialogMainWrapper)}>
                    <div className={classNames(styles.dialogImportLdapUserMainHeaderWrapper)}>
                        {link}
                        <DialogHeader
                            title={title}
                            displayCloseButton
                            closeClick={this.props.closeAddUserModal}
                            className={className}
                        />
                    </div>
                    <div >
                        {content}
                    </div>
                </div>
            </Dialog>
        );
    }
}